import Api from "./Api";
import axios from "axios";

let cancelDataRequest = null;

class UserDataService {
    getAll = async (params) => {
        if (cancelDataRequest) {
            cancelDataRequest();
        }
        const CancelToken = axios.CancelToken;

        const response = await Api().get('user', {
            params: params,
            cancelToken: new CancelToken(c => {
                cancelDataRequest = c;
            })
        })
        cancelDataRequest = null;
        return response;
    }

    get = async id => {
        return await Api().get(`user/${id}`)
    }

    update = async (activeUser) => {
        return await Api().put(`user/${activeUser.id}`, activeUser)
    }

    addNewProbe = async (user_id, probe) => {
        probe = {...probe, probe_id: probe.probe_id.id }
        return await Api().post(`user/${user_id}/probe`, probe)
    }

    editUserProbe = async (user_id, probe) => {
        return await Api().put(`user/${user_id}/probe/${probe.probe_id}`, probe)
    }

    deleteUserProbe = async (user_id, probe_id) => {
        return await Api().delete(`user/${user_id}/probe/${probe_id}`)
    }

    getAllPermissions = async () => {
        return await Api().get(`permission`)
    }
    updateUserPermissions = async (user_id, userPermissions) => {
        return await Api().put(`permission`, {
            user_id: user_id,
            user_permissions: userPermissions
        })
    }
}

export default new UserDataService();